import { useEffect, useState } from "react";

/**
 * Returns a Date that is captured once, when the component mounts.
 *
 * @returns  {Date}    A Date fixed at mount time
 */
export default function useNow(refreshMs = 0) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    if (!refreshMs) {
      return;
    }

    const interval = setInterval(() => setNow(new Date()), refreshMs);

    return () => clearInterval(interval);
  }, [refreshMs]);

  return now;
}
